import React from 'react';
import { Box } from '@mui/material';
import RelatedSectionShell, { TilesGrid } from './RelatedSectionShell';

// Use the same tile component the dashboard uses for measures.
// If your project names it differently, adjust the import:
import MeasureTile from '../tiles/MeasureTile';

import MeasuresTable from './tables/MeasuresTable';

const findMeasuresSection = (sections) =>
  (sections || []).find((s) =>
    s?.title && /how do customers measure success/i.test(String(s.title))
  ) || null;

const sectionTotalFrom = (sec) =>
  sec?.section_total_interviews ?? sec?.sectionTotal ?? 0;

export default function RelatedMeasures({ sections, customerStories = [], jobName }) {
  const measuresSec = React.useMemo(() => findMeasuresSection(sections), [sections]);
  if (!measuresSec) return null;

  const tiles = Array.isArray(measuresSec.tiles) ? measuresSec.tiles : [];
  const top3 = tiles.slice(0, 3);

  return (
    <RelatedSectionShell section={measuresSec}>
      {/* Top-3 tiles (same visuals as dashboard) */}
      <Box sx={{ mb: 2 }}>
        <TilesGrid
          tiles={top3}
          renderTile={(t) => (
            <MeasureTile {...t} sectionTotal={sectionTotalFrom(measuresSec)} />
          )}
        />
      </Box>

      {/* Full ranked table with expandable per-interview rows */}
      <MeasuresTable
        rowsSource={tiles}
        customerStories={customerStories}
        jobName={jobName}
      />
    </RelatedSectionShell>
  );
}
